export default "__VITE_ASSET__7b77faf6__"